import { throttle } from 'throttle-debounce';

export const stickyNav = {
	setupStickyNav: () => {
		let navLinks = document.querySelectorAll('.sticky-nav-block__ul > div a');
		let stickyNavBlockInstance = document.querySelector('.js-sticky-nav-block');
		let mainEl = document.querySelector('.main');
		let navEl = document.querySelector(".sticky-nav-block__nav")
		// Function to check if an element is in the viewport
		let isInViewport = (elem) => {
			let bounding = elem.getBoundingClientRect();
			return (
				bounding.top >= 0 &&
				bounding.left >= 0 &&
				bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
				bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
			);
		};

		let setupMobileNav = () => {
			let mobileTrigger = document.querySelector('.js-sticky-nav-trigger');

			mobileTrigger.addEventListener('click', () => {
				let parentEl = mobileTrigger.parentElement;
				parentEl.classList.toggle('state-open');
			});

			document.body.addEventListener('click', (event) => {
				if (!navEl.contains(event.target) && !mobileTrigger.contains(event.target)) {
					navEl.classList.remove('state-open');
				}
			});
		};

		let isExternalLink = (url) => {
			let linkEl = document.createElement('a');
			linkEl.href = url;
			// Compare the hostnames of the current site and the link
			return linkEl.hostname !== window.location.hostname;
		};


		// Function to update active state of navigation links based on scroll position
		let updateActiveNavItem = () => {

			navLinks.forEach(function(navLink) {
				navLink.classList.remove('active');
			});

			// Find the first section that is in the viewport and add active class to its corresponding navigation link
			for (let i = 0; i < navLinks.length; i++) {
				let navLink = navLinks[i];
				let sectionId = navLink.getAttribute('href').substring(1);
				let section = document.getElementById(sectionId);

				if (section && isInViewport(section)) {
					navLink.classList.add('active');
					break; // Stop looping after the first visible section is found
				}
			}
		};

		// Event listener for scroll event
		document.addEventListener('scroll', function() {
			updateActiveNavItem();
		});

		navLinks.forEach((navLink) => {
			let offsetAmount = navLink.getAttribute('data-offset') | 0;
			navLink.addEventListener('click', (e) => {
				if(!navLink.getAttribute('data-external')) {
					event.preventDefault();

					// Get the target section ID from the link's href attribute
					let targetId = navLink.getAttribute('href').substring(1);

					// Find the target section on the page
					let targetSection = document.getElementById(targetId);

					let offsetPosition = targetSection.offsetTop - (offsetAmount ? offsetAmount : document.querySelector(".js-sticky-nav-block").offsetHeight);

					// Scroll to the target section with offset smoothly
					window.scrollTo({
						top: offsetPosition,
						behavior: 'smooth'
					});

					navEl.classList.toggle('state-open');
				} else {
					let url = navLink.getAttribute('href')
					if (isExternalLink(url)) {
						// Open the link in a new window
						window.open(url, '_blank');
						// Prevent the default action of the link
						event.preventDefault();
					}
				}
			});
		});

	// Initial call to update active state on page load
		updateActiveNavItem();
		setupMobileNav();
		// Move the menu immediately after the header
		if(stickyNavBlockInstance && mainEl ) {
			mainEl.prepend(stickyNavBlockInstance);
			stickyNavBlockInstance.classList.add('state-visible');
		}

	},

	init: () => {
		stickyNav.setupStickyNav();
	},
};

document.addEventListener('DOMContentLoaded', () => {
	stickyNav.init();
});
